/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

define([
  "marionette",
  "jquery",
  "modules/topicsSplit/miniLearner/highlightedTranscript/template/highlightedTranscriptTemplate.html",
  "i18n/i18n",
  "jquery-ui",
  "jquery-ui/ui/widgets/draggable",
], function (Marionette, $, HighlightedTranscriptTemplate) {
  "use strict";

  const HighlightedTranscriptView = {};

  HighlightedTranscriptView.highlightedTranscriptView = Marionette.ItemView.extend({
    template: HighlightedTranscriptTemplate,
    onRender: function () {
      this.$el.i18n();
      const model = this.model;
      const _this = this;
      this.$el.find(".draggable").draggable({
        addClasses: false,
        appendTo: "body",
        distance: 20,
        opacity: 0.9,
        helper: "clone",
        cursor: "move",
        containment: "#main",
        cursorAt: { left: 0, top: 0 },
        start: function (event, ui) {
          //change style of the cloned draggable object
          $(ui.helper).addClass("draggable-active");
          _this.trigger("dragged:item");
        },
      });
      this.$el.find(".draggable").draggable("option", { model: model });
    },
    triggers: {
      "click #highlightedTranscriptLink": "select:transcript",
    },
  });

  return HighlightedTranscriptView;
});
